export const BrandQuote = ({ quote, id }) => (
  <div className="brand-quotations" data-testid={`${id}-quote`}>
    {quote.versions.map(({ language, paragraphs }) => (
      <figure className="brand-quote" lang={language} key={language} data-testid={`${id}-quote-${language}`}>
        <blockquote data-testid={`${id}-quote-${language}-text`}>
          {paragraphs.map((paragraph, index) => (
            <p key={index} data-testid={`${id}-quote-${language}-paragraph-${index}`}>
              {index === 0 && "“"}{paragraph}{index === paragraphs.length - 1 && "”"}
            </p>
          ))}
        </blockquote>
        <figcaption data-testid={`${id}-quote-${language}-author`}>— <cite>{quote.author}</cite></figcaption>
      </figure>
    ))}
  </div>
);